import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * 管理后台的页面名已经显示在顶部标题栏里，后台布局会把这个值设成 true，
 * PageHeader 就只渲染说明和操作按钮，不再重复一遍大标题。
 */
export const PageTitleInHeaderContext = React.createContext<boolean>(false);

export interface PageHeaderProps {
  title: string;
  description?: string;
  /** 右侧操作区：刷新 / 新增等按钮 */
  actions?: React.ReactNode;
  className?: string;
}

/** 页面级标题区：标题 + 描述 + 右侧操作，统一全站页头排版 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions,
  className,
}) => {
  const titleInHeader: boolean = React.useContext(PageTitleInHeaderContext);
  return (
    <div
      className={cn(
        'mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <div className="min-w-0">
        {!titleInHeader && (
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        )}
        {description && (
          <p
            className={cn(
              'text-sm text-muted-foreground',
              !titleInHeader && 'mt-1',
            )}
          >
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export { PageHeader };
